export default __webpack_public_path__ + "static/media/aligner.bcc8e746.png";